import React, { useState } from "react";

const VideoShowcaseSection = () => {
  const videos = [
    {
      id: "dgCeG7X9II4",
      title: "Welcome to Revibe 🌅",
      description: "Transform Your Health from Home",
      // thumbnail: "https://img.youtube.com/vi/hHW1oY26kxQ/hqdefault.jpg",
    },
    {
      id: "tc9YpaSDREQ",
      title: "Health & Happiness",
      description: "Meet the Experts Behind Revibe 4 Trainers, 1 Mission",
      // thumbnail: "https://img.youtube.com/vi/LXb3EKWsInQ/hqdefault.jpg",
    },
    // {
    //   id: "dQw4w9WgXcQ",
    //   title: "Full Body Stretch 💪",
    //   description:
    //     "Relax your muscles and improve flexibility with this guided stretch.",
    //   thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    // },
  ];

  const [playingIndex, setPlayingIndex] = useState(null);

  return (
    <section className="w-full bg-gradient-to-b from-white to-[#f8fafc] py-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-center text-gray-900">
          🎥 Our <span className="text-[#C5F122]">Video Collection</span>
        </h2>
        <p className="mt-4 text-center text-gray-600 text-lg max-w-2xl mx-auto">
          Watch and learn from our latest wellness and fitness guides.
        </p>

        {/* Video Grid */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {videos.map((video, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative w-full aspect-video bg-black">
                {playingIndex === index ? (
                  <iframe
                    src={`https://www.youtube.com/embed/${video.id}?autoplay=1&mute=0&origin=https://getrevibe.app`}
                    title={video.title}
                    className="w-full h-full rounded-t-2xl"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <>
                    <img
                      src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                      alt={video.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                      <button
                        onClick={() => setPlayingIndex(index)}
                        className="bg-[#C5F122] text-gray-900 font-semibold px-6 py-2 rounded-full shadow-md hover:bg-[#b8ea03] transition"
                      >
                        ▶ Watch Video
                      </button>
                    </div>
                  </>
                )}
              </div>

              <div className="p-5">
                <h3 className="text-lg font-bold text-gray-900 group-hover:text-[#C5F122] transition">
                  {video.title}
                </h3>
                <p className="mt-2 text-sm text-gray-600">
                  {video.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* <p className="mt-10 text-center text-gray-500 text-sm">
          ✨ More videos coming soon — stay tuned!
        </p> */}
      </div>
    </section>
  );
};

export default VideoShowcaseSection;
